import {
  Plus,
  ArrowLeft,
  Search,
  Filter,
  MoreVertical,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Calendar,
  UserIcon,
  User,
  Phone,
  Construction,
  Mail,
  Eye,
  X,
  Clock, // Add this
  CheckCircle,
  MailIcon,
  PhoneIcon,
  PencilLine,
  Video,
  ExternalLink,
} from "lucide-react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FeatureCard from "./../../components/FeatureCard";
import DoneAll from "../../images/done_all.svg";
import check from "../../images/check_circle.svg";
import filterList from "../../images/filter_list.svg";
import Delete from "../../images/delete.svg";
import Archive from "../../images/archive.svg";
import { apiClient } from "../../lib/apiClient";
import Pagination from "../../components/pagination";
import StatusFilter from "../../components/StatusFilter";
import { useAuth } from "../../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "../../i18n";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";
import { PopupModal } from "react-calendly";
import { useRef } from "react";
import {
  ALL_STATUSES,
  MAIN_STATUSES,
  PROSPECT_SUB_STATUSES,
} from "../../constants/statusConstants";
import GlobalIcon from "../../images/global.svg";

export default function LeadManagement() {
  const { t } = useTranslation();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [showAddModal, setShowAddModal] = useState(false);
  const [addFormData, setAddFormData] = useState({
    incomeRange: "",
    livingSituation: "",
    canton: "",
    pillar3a: "",
    contact: { name: "", phone: "", email: "", birthDate: "" },
    // termsAccepted: false,
  });
  const [addFormErrors, setAddFormErrors] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [addFormSubmitting, setAddFormSubmitting] = useState(false);
  const [openSubMenuId, setOpenSubMenuId] = useState(null);
  const [subMenuPosition, setSubMenuPosition] = useState({ top: 0, left: 0 });
  const statusRefsMap = useRef({});

  const [activeMenu, setActiveMenu] = useState(null);
  const [statusFilter, setStatusFilter] = useState("All");
  const [counts, setCounts] = useState({});
  const [selectedAction, setSelectedAction] = useState(null);
  const [notes, setNotes] = useState("");
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingLeadId, setEditingLeadId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [meetingData, setMeetingData] = useState({
    date: "",
    time: "",
    link: "",
  });
  const [meetingSubmitting, setMeetingSubmitting] = useState(false);
  const [subMenuSearchTerm, setSubMenuSearchTerm] = useState("");
  const [meetingLead, setMeetingLead] = useState(null);
  const dropdownRef = useRef(null);
  const location = useLocation();
  useEffect(() => {
    if (!openSubMenuId) {
      setSubMenuSearchTerm(""); // Reset search when menu closes
    }
  }, [openSubMenuId]);
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);

    const currentPath = window.location.pathname;
    let pathParts = currentPath.split("/").filter(Boolean);

    // Identify where 'admin' is
    const adminIndex = pathParts.indexOf("admin");

    if (adminIndex !== -1) {
      // The language code is expected right after 'admin' (index 1 in /admin/en/...)
      const langIndex = adminIndex + 1;
      const currentLangToken = pathParts[langIndex];
      const isLangToken =
        currentLangToken === "en" || currentLangToken === "de";

      if (lng === "de") {
        // Switching to German: Remove 'en' if it exists
        if (isLangToken && currentLangToken === "en") {
          pathParts.splice(langIndex, 1);
        }
      } else {
        // Switching to English: Add 'en' if it's missing, or replace 'de'
        if (isLangToken) {
          pathParts[langIndex] = "en";
        } else {
          pathParts.splice(langIndex, 0, "en");
        }
      }
    }

    // Reconstruct the URL properly
    const newPath = `/${pathParts.join("/")}${window.location.search}${window.location.hash}`;

    // Use navigate to move to the new URL without losing state
    navigate(newPath);
    setIsOpen(false);
  };

  const menuOptions = [
    { name: "Mark Contacted", icon: DoneAll },
    { name: "Follow Up", icon: Calendar },
    { name: "Mark Completed", icon: check },
    { name: "View Details", icon: Eye },
  ];
  const allLeads = [
    {
      id: 1,
      name: "Marc Müller",
      phone: "+41 79 123 45 10",
      canton: "Zürich",
      createdAt: "19/01/2026",
      followup: "05:30 PM",
      status: "New",
      profilePic: "https://i.pravatar.cc/150?u=1",
    },
    {
      id: 2,
      name: "Sophie Koch",
      phone: "+41 79 123 45 11",
      canton: "Bern",
      createdAt: "19/01/2026",
      followup: "-",
      status: "Completed",
      profilePic: "https://i.pravatar.cc/150?u=2",
    },
    {
      id: 3,
      name: "Lukas Weber",
      phone: "+41 79 123 45 12",
      canton: "Luzern",
      createdAt: "19/01/2026",
      followup: "02:00 PM",
      status: "Contacted",
      profilePic: "https://i.pravatar.cc/150?u=3",
    },
    {
      id: 4,
      name: "Elena Fischer",
      phone: "+41 79 123 45 13",
      canton: "Genève",
      createdAt: "18/01/2026",
      followup: "-",
      status: "Follow Up",
      profilePic: "https://i.pravatar.cc/150?u=4",
    },
    {
      id: 5,
      name: "Jan Schneider",
      phone: "+41 79 123 45 14",
      canton: "Basel",
      createdAt: "18/01/2026",
      followup: "10:30 AM",
      status: "New",
      profilePic: "https://i.pravatar.cc/150?u=5",
    },
    {
      id: 6,
      name: "Anna Steiner",
      phone: "+41 79 123 45 15",
      canton: "Zürich",
      createdAt: "17/01/2026",
      followup: "-",
      status: "Completed",
      profilePic: "https://i.pravatar.cc/150?u=6",
    },
    {
      id: 7,
      name: "Thomas Meyer",
      phone: "+41 79 123 45 16",
      canton: "Bern",
      createdAt: "17/01/2026",
      followup: "04:15 PM",
      status: "Contacted",
      profilePic: "https://i.pravatar.cc/150?u=7",
    },
    {
      id: 8,
      name: "Laura Wagner",
      phone: "+41 79 123 45 17",
      canton: "St. Gallen",
      createdAt: "16/01/2026",
      followup: "-",
      status: "Follow Up",
      profilePic: "https://i.pravatar.cc/150?u=8",
    },
    {
      id: 9,
      name: "Daniel Vogt",
      phone: "+41 79 123 45 18",
      canton: "Luzern",
      createdAt: "16/01/2026",
      followup: "09:00 AM",
      status: "New",
      profilePic: "https://i.pravatar.cc/150?u=9",
    },
    {
      id: 10,
      name: "Julia Berg",
      phone: "+41 79 123 45 19",
      canton: "Zug",
      createdAt: "15/01/2026",
      followup: "-",
      status: "Completed",
      profilePic: "https://i.pravatar.cc/150?u=10",
    },
  ];

  const updateSubMenuPosition = (lead) => {
    const statusElement = statusRefsMap.current[lead.id];
    if (statusElement) {
      const rect = statusElement.getBoundingClientRect();
      setSubMenuPosition({
        top: rect.bottom + 5,
        left: rect.left,
      });
    }
  };
  const hasChanges = () => {
    const statusChanged =
      selectedAction && selectedAction !== selectedLead?.status;
    const notesChanged = notes.trim() !== originalNotes.trim();
    return statusChanged || notesChanged;
  };
  useEffect(() => {
    if (!openSubMenuId) return;

    const handleScroll = () => {
      const lead = leads.find((l) => l.id === openSubMenuId);
      if (lead) updateSubMenuPosition(lead);
    };

    const handleClick = () => setOpenSubMenuId(null);

    window.addEventListener("scroll", handleScroll, true); // true = capture phase catches all scroll events including nested containers
    window.addEventListener("click", handleClick);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
      window.removeEventListener("click", handleClick);
    };
  }, [openSubMenuId, leads]);

  const fetchLeads = async () => {
    try {
      setLoading(true);
      setFetchError(null);
      const statusParam = statusFilter === "Meetings" ? "Meeting-Scheduled" : statusFilter;

      const params = new URLSearchParams({
        search: searchTerm || "",
        page: currentPage,
        limit: recordsPerPage,
        status: statusParam,
      });

      const response = await apiClient.get(`lead?${params.toString()}`);
      console.log("response", response);

      if (response.success && response.data) {
        const freshLeads = response.data.data;
        setLeads(freshLeads);
        setTotal(response.data.total);
        setCounts(response.data.counts || {});
        return freshLeads;
      } else {
        throw new Error("Record not found");
      }
    } catch (err) {
      setFetchError(err.message || "Failed to fetch record");
      return null;
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLeads();
  }, [searchTerm, currentPage, recordsPerPage, statusFilter]);

  useEffect(() => {
    // Disable background scroll if either the details sidebar or the add/edit modal is open
    if (selectedLead || showAddModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedLead, showAddModal]); // Added showAddModal here

  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  // const handleStatusChange = async (leadId, newStatus) => {
  //   if (newStatus === "Meeting-Scheduled") {
  //     // 1. Open the Calendly Widget instead of updating backend immediately
  //     setIsCalendlyOpen(true);
  //   } else {
  //     // 2. For other statuses, proceed with normal update
  //     updateLeadStatusOnBackend(leadId, newStatus);
  //   }
  // };
  const onDateScheduled = async (e) => {
    // Calendly 'onEventScheduled' doesn't always provide the date in the event object
    // Depending on your setup, you might fetch the last booking via Calendly API
    // or simply update the status to indicate a meeting is now set.

    try {
      await apiClient.put(`/leads/${selectedLead.id}/status`, {
        status: "Meeting-Scheduled",
        // If you use Calendly webhooks, the date might come from there,
        // otherwise, you can pass a generic "scheduled" flag here.
        scheduled_at: new Date().toISOString(),
      });

      toast.success("Meeting scheduled and status updated!");
      setIsCalendlyOpen(false);
      fetchLeads(); // Refresh list
    } catch (err) {
      toast.error("Status update failed after scheduling");
    }
  };

  const validateAddName = (v) => (v.trim() ? "" : "Name is required");
  const validateAddEmail = (v) => {
    const s = v.trim();
    if (!s) return "Email is required";
    if (!s.includes("@") || !s.includes(".")) return "Invalid email";
    return "";
  };
  const validateAddPhone = (v) => {
    const c = v.trim().replace(/[\s\-\(\)\+\/]/g, "");
    if (!c) return "Phone is required";
    if (c.length < 9 || c.length > 12) return "Phone must be 9–12 digits";
    return "";
  };

  const isAddFormValid = () =>
    addFormData.incomeRange &&
    addFormData.livingSituation &&
    addFormData.canton &&
    addFormData.pillar3a &&
    addFormData.contact.name.trim() &&
    // addFormData.contact.email.trim() &&
    addFormData.contact.phone.trim();
  // addFormData.termsAccepted;

  const handleAddLead = async () => {
    const nameErr = validateAddName(addFormData.contact.name);
    // const emailErr = validateAddEmail(addFormData.contact.email);
    const phoneErr = validateAddPhone(addFormData.contact.phone);
    setAddFormErrors({ name: nameErr, phone: phoneErr });
    if (nameErr || phoneErr) return;

    try {
      setAddFormSubmitting(true);
      await apiClient.post("lead", addFormData);
      setShowAddModal(false);
      setAddFormData({
        incomeRange: "",
        livingSituation: "",
        canton: "",
        pillar3a: "",
        contact: { name: "", phone: "", email: "" },
        // termsAccepted: false,
      });
      setAddFormErrors({ name: "", email: "", phone: "" });
      fetchLeads();
    } catch (e) {
      console.error(e);
    } finally {
      setAddFormSubmitting(false);
    }
  };

  // Inside your component or where these are defined
  const incomeOptions = [
    { key: "Under CHF 50,000" },
    { key: "CHF 50,000–120,000" },
    { key: "CHF 120,000–180,000" },
    { key: "Over CHF 180,000" },
  ];

  const livingOptions = [
    { key: "Ledig, ohne Kinder" },
    { key: "Ledig, mit Kindern" },
    { key: "Verheiratet, ohne Kinde" },
    { key: "Verheiratet, mit Kindern" },
    { key: "In eingetragener Partnerschaft" },
    { key: "Verwitwet / Geschieden" },
  ];

  const pillar3aOptions = [
    { label: t("quiz.pillar.yes"), value: "Yes" },
    { label: t("quiz.pillar.no"), value: "No" },
  ];

  const cantonOptions = [
    "Aargau",
    "Appenzell Ausserrhoden",
    "Appenzell Innerrhoden",
    "Basel-Landschaft",
    "Basel-Stadt",
    "Bern",
    "Fribourg",
    "Geneva",
    "Glarus",
    "Graubünden",
    "Jura",
    "Lucerne",
    "Neuchâtel",
    "Nidwalden",
    "Obwalden",
    "Schaffhausen",
    "Schwyz",
    "Solothurn",
    "St. Gallen",
    "Thurgau",
    "Ticino",
    "Uri",
    "Valais",
    "Vaud",
    "Zug",
    "Zurich",
  ];

  const pillarsOption = [
    "Säule 3a (gebundene Vorsorge)",
    "Säule 3b (freie Vorsorge)",
    "Pensionskasse (BVG) freiwillig aufgestockt",
    "Keine Einzahlungen getätigt",
  ];

  const getStatusStyles = (status) => {
    const s = status?.toLowerCase().replace(/[-–—]/g, " ").trim() || "";

    if (s === "new") return "bg-blue-100 text-blue-600";
    if (s === "completed") return "bg-emerald-100 text-emerald-600";
    if (s === "follow up") return "bg-purple-100 text-purple-600";
    if (s.includes("spoke") && s.includes("follow"))
      return "bg-amber-100 text-amber-600";
    if (s === "contacted") return "bg-orange-100 text-orange-600";
    if (s === "meeting scheduled" || s === "meetings")
      return "bg-cyan-100 text-cyan-600";
    if (s === "prospects") return "bg-blue-50 text-blue-500";
    if (s === "deals won") return "bg-emerald-100 text-emerald-600";
    if (s === "deals lost") return "bg-rose-100 text-rose-600";

    // ✅ "not interested" BEFORE "interested"
    if (
      s.includes("not interested") ||
      s.includes("not relevant") ||
      s.includes("wrong") ||
      s.includes("duplicate") ||
      s.includes("dnc")
    )
      return "bg-red-100 text-red-600";
    if (s.includes("interested")) return "bg-green-100 text-green-600";

    if (s.includes("spoke")) return "bg-amber-100 text-amber-600";
    if (s.includes("whatsapp") || s.includes("email"))
      return "bg-indigo-100 text-indigo-600";
    if (s.includes("waiting") || s.includes("scheduled"))
      return "bg-cyan-100 text-cyan-600";
    return "bg-slate-100 text-slate-600";
  };

  const cards = [
    { icon: User, desc: "All Leads", leads: allLeads },
    {
      icon: Calendar,
      desc: "New",
      leads: allLeads.filter((l) => l.status === "New"),
    },
    {
      icon: Calendar,
      desc: "Contacted",
      leads: allLeads.filter((l) => l.status === "Contacted"),
    },
    {
      icon: Calendar,
      desc: "Follow-Up",
      leads: allLeads.filter((l) => l.status === "Follow Up"),
    },
    {
      icon: Calendar,
      desc: "Completed",
      leads: allLeads.filter((l) => l.status === "Completed"),
    },
  ];
  const STATUS_ICONS = {
    All: Calendar,
    New: Plus,
    Prospects: User,
    Meetings: Video,
    "Deals Won": CheckCircle,
    "Deals Lost": X,
  };

  const CARD_LABELS = {
    All: t("leadManagement.cards.all"),
    New: t("leadManagement.cards.new"),
    Prospects: t("leadManagement.cards.prospects"),
    Meetings: t("leadManagement.cards.meetings"),
    "Deals Won": t("leadManagement.cards.won"),
    "Deals Lost": t("leadManagement.cards.lost"),
  };

  const displayStatuses = [
    "All",
    "New",
    "Prospects",
    "Meetings",
    "Deals Won",
    "Deals Lost",
  ];
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const countsArray = displayStatuses.map((status) => ({
  //   desc: status,
  //   label: CARD_LABELS[status] || status,
  //   count: counts[status] || 0,
  //   icon: STATUS_ICONS[status] || Calendar,
  // }));
  const countsArray = displayStatuses.map((status) => ({
  desc: status,
  label: CARD_LABELS[status] || status,
  count: status === "Meetings" ? (counts["Meeting-Scheduled"] || 0) : (counts[status] || 0),
  icon: STATUS_ICONS[status] || Calendar,
}));
  const today = new Date();

  // Minimum allowed DOB (max age = 60)
  // const minDate = new Date(
  //   today.getFullYear() - 60,
  //   today.getMonth(),
  //   today.getDate(),
  // )
  //   .toISOString()
  //   .split("T")[0];

  const minDate = "1900-01-01";

  // Maximum allowed DOB (min age = 18)
  const maxDate = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate(),
  )
    .toISOString()
    .split("T")[0];
  // const isActive = (s) => currentStep === s;
  // const isCompleted = (s) => currentStep > s;
  const optBtn = (sel) =>
    `px-4 py-3 rounded-xl border text-sm text-[#475569] font-medium transition-all text-left ${
      sel
        ? "bg-[#DBF1FF] border-[#036EA4]"
        : "bg-white hover:bg-blue-50/50 border-gray-100"
    }`;

  const validateDateOfBirth = (dob) => {
    if (!dob) return t("Date of birth is required");

    const birthDate = new Date(dob);
    const today = new Date();

    if (isNaN(birthDate.getTime())) return t("Invalid date");
    if (birthDate >= today) return t("Date of birth must be in the past");

    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const actualAge =
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ? age - 1
        : age;

    if (actualAge > 120) return t("Please enter a valid date of birth");
    if (actualAge > 60)
      return t("Persons over 60 are not eligible for insurance policy changes"); // ✅ pehle 60 check
    if (actualAge < 18) return t("You must be at least 18 years old");

    return null;
  };
  // const handleSave = async () => {
  //   if (!selectedAction) return;

  //   const statusMap = {
  //     contacted: "Contacted",
  //     completed: "Completed",
  //   };

  //   const payload = {
  //     status: statusMap[selectedAction],
  //     ...(notes.trim() ? { notes: notes.trim() } : {}),
  //   };

  const [originalNotes, setOriginalNotes] = useState("");
  // Updated handleSave function
  const handleSave = async () => {
    if (!selectedLead) return;

    const statusChanged =
      selectedAction && selectedAction !== selectedLead.status;
    const notesChanged = notes.trim() !== originalNotes.trim();

    if (!statusChanged && !notesChanged) return;

    try {
      const payload = {};

      if (statusChanged) {
        payload.status = selectedAction;
      }

      if (notesChanged) {
        payload.notes = notes.trim();
      }
      const response = await apiClient.post(`lead/${selectedLead.id}`, payload);
      if (response.success) {
        setSelectedLead(null);
        setSelectedAction(null);
        setNotes("");
        fetchLeads();
        setOriginalNotes(notes.trim());
        if (statusChanged) setSelectedAction(null);
      } else {
        // throw new Error("Failed to update");
      }
    } catch (err) {
      console.error("Save error:", err);
    }
  };

  const resetAddForm = () => {
    setAddFormData({
      incomeRange: "",
      livingSituation: "",
      canton: "",
      pillar3a: "",
      contact: { name: "", phone: "", email: "", birthDate: "" },
      // termsAccepted: false,
    });

    setAddFormErrors({ name: "", email: "", phone: "", birthDate: "" });
  };
  // const handleStatusChange = async (leadId, newStatus) => {
  //   try {
  //     const payload = { status: newStatus };

  //     // If scheduling a meeting, we might wait for the date or send a default
  //     if (newStatus === "Meeting-Scheduled") {
  //       setIsCalendlyOpen(true);
  //       // We don't update the backend yet; we wait for the Calendly callback
  //       return;
  //     }

  //     const response = await apiClient.put(`/leads/${leadId}/status`, payload);
  //     // Refresh leads list or update local state
  //     setLeads((prev) =>
  //       prev.map((l) => (l.id === leadId ? { ...l, status: newStatus } : l)),
  //     );
  //     toast.success(`Status updated to ${newStatus}`);
  //   } catch (err) {
  //     toast.error("Failed to update status");
  //   }
  // };

  const handleStatusChange = async (leadId, newStatus) => {
    try {
      if (newStatus === "Meeting-Scheduled") {
        setIsCalendlyOpen(true);
        return;
      }

      const response = await apiClient.post(`lead/${leadId}`, {
        status: newStatus,
      });

      if (response.success) {
        setSelectedAction(newStatus);
        toast.success(`Status updated to ${newStatus}`);
        const freshLeads = await fetchLeads();
        if (freshLeads && selectedLead) {
          const fresh = freshLeads.find((l) => l.id === leadId);
          if (fresh) setSelectedLead(fresh);
        }
      }
    } catch (err) {
      toast.error("Failed to update status");
    }
  };
  // Add this state to track meeting date changes if not already in your lead object
  const handleUpdateMeetingDate = async (leadId, newDate) => {
    // 1. Update local UI state immediately for responsiveness
    setLeads((prevLeads) =>
      prevLeads.map((lead) =>
        lead.id === leadId ? { ...lead, meetingDate: newDate } : lead,
      ),
    );

    if (selectedLead && selectedLead.id === leadId) {
      setSelectedLead({ ...selectedLead, meetingDate: newDate });
    }

    try {
      // 2. Use the correct endpoint pattern: lead/${id}
      const response = await apiClient.post(`lead/${leadId}`, {
        meetingDate: newDate, // Ensure this matches your backend key
      });

      if (response.success) {
        toast.success("Meeting date updated successfully");
      }
    } catch (error) {
      console.error("Error updating meeting date:", error);
      toast.error("Failed to update meeting date");
    }
  };
  const formatGermanDate = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "_._._";

    return date.toLocaleDateString("de-DE");
  };

  const formatGermanDateTime = (dateTimeString) => {
    if (!dateTimeString) return "-";

    const date = new Date(dateTimeString);
    if (isNaN(date.getTime())) return "-";

    const datePart = date.toLocaleDateString("de-DE"); // This gives DD.MM.YYYY with dots
    const timePart = date.toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    }); // This gives HH:MM

    return `${datePart} ${timePart}`;
  };

  // console.log("leads:", selectedLead.notes);

  //   const handleSubStatusChange = async (leadId, newStatus) => {
  //   try {
  //     const response = await apiClient.post(`lead/${leadId}`, { status: newStatus });
  //     if (response.success) {
  //       setLeads((prev) =>
  //         prev.map((l) => (l.id === leadId ? { ...l, status: newStatus } : l)),
  //       );
  //       toast.success(`Status updated to ${newStatus}`);
  //       setOpenSubMenuId(null);
  //     }
  //   } catch (err) {
  //     console.error("Sub-status error:", err);
  //     toast.error("Failed to update sub-status");
  //   }
  // };

  const handleSubStatusChange = async (leadId, newStatus) => {
    try {
      const response = await apiClient.post(`lead/${leadId}`, {
        status: newStatus,
      });
      if (response.success) {
        setSelectedAction(newStatus);
        toast.success(`Status updated to ${newStatus}`);
        setOpenSubMenuId(null);
        const freshLeads = await fetchLeads();
        if (freshLeads && selectedLead) {
          const fresh = freshLeads.find((l) => l.id === leadId);
          if (fresh) setSelectedLead(fresh);
        }
      }
    } catch (err) {
      console.error("Sub-status error:", err);
      toast.error("Failed to update sub-status");
    }
  };

  const handleMeetingSubmit = async () => {
    // console.log("first", meetingLead);
    if (!meetingLead) return;

    try {
      setMeetingSubmitting(true);
      const response = await apiClient.post(`lead/${meetingLead.id}`, {
        status: "Meeting-Scheduled",
        meetingDate: meetingData.date,
        meetingTime: meetingData.time,
        meetingLink: meetingData.link,
      });

      if (response.success) {
        toast.success("Meeting details updated successfully");
        setShowMeetingModal(false);
        setMeetingLead(null);
        fetchLeads();
      } else {
        toast.error("Failed to update meeting details");
      }
    } catch (error) {
      console.error("Meeting update error:", error);
      toast.error("An error occurred while updating meeting details");
    } finally {
      setMeetingSubmitting(false);
    }
  };

  console.log("lead statuses:", leads);
  return (
    <section className="w-full min-h-[calc(100vh-100px)] overflow-y-auto p-6 bg-white md:p-10 flex flex-col overflow-hidden">
      <div className="mx-auto max-w-[1728px] w-full flex-1 flex flex-col min-h-0">
        {/* Header Section */}
        <div className="relative flex flex-col justify-between gap-4 mb-2 border-b border-gray-200 sm:flex-row sm:items-center">
  
  {/* Title + Subtitle */}
  <div className="flex flex-col gap-1 p-4 pb-6 pr-28 sm:pr-4">
    <div className="flex items-center gap-3">
      <button
        onClick={() => navigate(`/${i18n.language}`)}
        className="p-1 -ml-1 transition-colors rounded-full hover:bg-gray-100 text-slate-600"
      >
        <ArrowLeft size={20} />
      </button>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 font-poppins">
        {t("leadManagement.title")}
      </h1>
    </div>
    <p className="pl-[32px] text-sm text-slate-500">
      {t("leadManagement.subtitle")}
    </p>
  </div>

  {/* Actions: absolute on mobile, static on sm+ */}
  <div className="absolute top-4 right-4 sm:static flex items-center gap-3 sm:p-4">
    <button
      onClick={() => {
        logout();
        navigate("/login");
      }}
      className="text-[#007AB7] text-[14px] font-medium transition-colors duration-200 cursor-pointer hover:opacity-90 border border-[#007AB7] bg-transparent px-2 py-1 rounded-lg whitespace-nowrap"
    >
      {t("leadManagement.logout")}
    </button>

    <div className="relative inline-block" ref={dropdownRef} style={{ zIndex: 50 }}>
      <button
        type="button"
        className="flex bg-black items-center justify-center p-2 transition-colors rounded-full cursor-pointer hover:opacity-90"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        <img src={GlobalIcon} alt="Language" className="w-5 h-5" />
      </button>

      {isOpen && (
        <div className="absolute right-0 w-40 mt-2 overflow-hidden bg-white border shadow-2xl top-full border-slate-200 rounded-xl">
          <div className="flex flex-col">
            <button
              onClick={() => changeLanguage("en")}
              className="flex items-center gap-3 px-4 py-3 text-sm border-b text-slate-700 hover:bg-slate-50 border-slate-100"
            >
              <img src="https://flagcdn.com/w40/gb.png" className="w-5 h-auto rounded-sm" alt="EN" />
              <span>English</span>
            </button>
            <button
              onClick={() => changeLanguage("de")}
              className="flex items-center gap-3 px-4 py-3 text-sm text-slate-700 hover:bg-slate-50"
            >
              <img src="https://flagcdn.com/w40/de.png" className="w-5 h-auto rounded-sm" alt="DE" />
              <span>Deutsch</span>
            </button>
          </div>
        </div>
      )}
    </div>
  </div>

</div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 gap-6 my-10 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
          {countsArray?.map((card, index) => (
            <FeatureCard
              key={index}
              icon={card.icon}
              title={card.label}
              count={card.count}
              isActive={statusFilter === card.desc}
              isAnyActive={statusFilter !== "All"}
              onClick={() => {
                // Toggle off if already active, else set filter
                setStatusFilter(statusFilter === card.desc ? "All" : card.desc);
                setCurrentPage(1);
              }}
            />
          ))}
        </div>

        {/* Search & Filter */}
        <div className="flex flex-col gap-2  sm:flex-row items-center justify-between mb-4">
          <div className="relative flex items-center w-full sm:max-w-xs">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              className="w-full p-2 pl-10 text-sm transition-all bg-white border border-gray-200 outline-none rounded-xl focus:border-gray-100"
              placeholder={t("leadManagement.searchPlaceholder")}
            />
            <Search size={18} className="absolute left-3 text-slate-400" />
          </div>
          <button
            onClick={() => setShowAddModal(true)}
            className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[#007AB7] text-white px-4 py-2 rounded-xl font-semibold text-sm hover:bg-[#005f8d] transition-all"
          >
            <Plus size={16} /> {t("leadManagement.addLead")}
          </button>
          {/* <StatusFilter
            currentStatus={statusFilter}
            setCurrentStatus={setStatusFilter}
          /> */}
        </div>

        {/* Table Container */}
        <div className="flex-1 min-h-[300px] mt-4 overflow-hidden bg-white rounded-t-xl border border-[#e5e7eb] shadow-xl flex flex-col">
          <div className="overflow-auto custom-scrollba flex-1">
            {" "}
            {/* This div now handles the scrolling */}
            <table className="w-full text-left">
              <thead className="sticky top-0 z-20 bg-slate-50">
                {" "}
                {/* Added sticky header */}
                <tr className=" bg-slate-50/50 border-b border-[#e5e7eb]">
                  {/* <th className="w-10 px-4 py-4 text-center">
                    <input
                      type="checkbox"
                      className="rounded border-slate-300 text-[#007AB7]"
                    />
                  </th> */}
                  <th className="px-6 py-4 text-[14px] uppercase font-semibold text-[#6f6f6f]">
                    {t("leadManagement.table.lead")}
                  </th>
                  <th className="px-6 py-4 text-[14px] uppercase font-semibold text-[#6f6f6f]">
                    {t("leadManagement.table.status")}
                  </th>
                  <th className="px-6 py-4 text-[14px] uppercase font-semibold text-[#6f6f6f]">
                    {t("leadManagement.table.communication")}
                  </th>
                  <th className="px-6 py-4 text-[14px] uppercase font-semibold text-[#6f6f6f]">
                    {t("leadManagement.table.canton")}
                  </th>
                  <th className="px-6 py-4 text-[14px] uppercase font-semibold text-[#6f6f6f]">
                    {t("leadManagement.table.createdAt")}
                  </th>
                  {/* <th className="px-6 py-4 text-[14px] uppercase font-semibold text-[#6f6f6f]">
                    Notes
                  </th> */}
                  <th className="px-6 py-4 text-[14px] uppercase font-semibold text-center text-[#6f6f6f]">
                    {t("leadManagement.table.actions")}
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {loading ? (
                  <tr>
                    <td colSpan={6} className="px-6 text-center h-[400px]">
                      <div className="flex items-center justify-center gap-3 text-slate-400">
                        <svg
                          className="animate-spin h-10 w-10 text-[#007AB7]"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                          />
                        </svg>
                      </div>
                    </td>
                  </tr>
                ) : leads?.length > 0 ? (
                  leads?.map((lead) => (
                    <tr
                      key={lead.id}
                      // onClick={() => {
                      //   setSelectedLead(lead);
                      //   setNotes(lead?.notes || "");
                      //   setSelectedAction(
                      //     lead?.status?.toLowerCase() === "contacted"
                      //       ? "contacted"
                      //       : lead?.status?.toLowerCase() === "completed"
                      //         ? "completed"
                      //         : null,
                      //   );
                      // }}
                      onClick={() => {
                        setSelectedLead(lead);
                        setNotes(lead?.notes || "");
                        setSelectedAction(lead?.status || null);
                        setOriginalNotes(lead?.notes || ""); // Important for change detection
                        setSelectedAction(null);
                      }}
                      className="transition-colors hover:bg-slate-50/50 cursor-pointer"
                    >
                      {/* <td className="px-4 py-4 text-center">
                      <input
                        type="checkbox"
                        className="rounded border-slate-300 text-[#007AB7]"
                      />
                    </td> */}
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          {/* <img
                          src={lead.profilePic}
                          className="object-cover border rounded-full w-9 h-9 border-slate-100"
                        /> */}
                          <span className="text-sm font-medium text-slate-700">
                            {lead?.contact?.name ?? "-"}
                          </span>
                          {lead.status === "Meeting-Scheduled" &&
                            (lead.meetingDate || lead.meetingTime) && (
                              <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-cyan-50 text-cyan-700 text-[14px] font-bold border border-cyan-100 ml-2 whitespace-nowrap">
                                <Clock size={10} />
                                {lead.meetingDate &&
                                  formatGermanDate(lead.meetingDate)}
                                {lead.meetingTime
                                  ? ` ${lead.meetingTime}`
                                  : lead.meetingDate?.includes("T")
                                    ? ` ${lead.meetingDate.split("T")[1]}`
                                    : ""}
                              </span>
                            )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div
                          ref={(el) => {
                            if (el) statusRefsMap.current[lead.id] = el;
                          }}
                          className="flex items-center gap-1 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (openSubMenuId === lead.id) {
                              setOpenSubMenuId(null);
                            } else {
                              setOpenSubMenuId(lead.id);
                              setTimeout(() => updateSubMenuPosition(lead), 0);
                            }
                          }}
                        >
                          <span
                            className={`px-3 flex gap-1 items-center py-1 text-[11px] font-bold rounded-md uppercase tracking-wider ${getStatusStyles(lead.status)}`}
                          >
                            {t(`leadStatus.${lead?.status}`) || lead?.status}{" "}
                            <ChevronRight
                              size={14}
                              className="rotate-90 text-slate-400 transition-colors"
                            />
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center gap-3">
                          {/* Email Action */}
                          {lead?.contact?.email ? (
                            <a
                              href={`mailto:${lead?.contact?.email}`}
                              onClick={(e) => e.stopPropagation()}
                              className="p-2 rounded-full bg-slate-50 border border-slate-100 text-slate-400 hover:text-[#007AB7] hover:border-[#007AB7] hover:bg-blue-50 transition-all duration-200"
                              title={`Email: ${lead?.contact?.email}`}
                            >
                              <Mail className="w-4 h-4" />
                            </a>
                          ) : (
                            <div className="p-2 text-slate-200 cursor-not-allowed">
                              <Mail className="w-4 h-4" />
                            </div>
                          )}

                          {/* Phone Action */}
                          {lead?.contact?.phone ? (
                            <a
                              href={`tel:${lead?.contact?.phone}`}
                              onClick={(e) => e.stopPropagation()}
                              className="p-2 rounded-full bg-slate-50 border border-slate-100 text-slate-400 hover:text-[#007AB7] hover:border-[#007AB7] hover:bg-blue-50 transition-all duration-200"
                              title={`Call: ${lead?.contact?.phone}`}
                            >
                              <Phone className="w-4 h-4" />
                            </a>
                          ) : (
                            <div className="p-2 text-slate-200 cursor-not-allowed">
                              <Phone className="w-4 h-4" />
                            </div>
                          )}
                          {/* Calendly / Meeting Scheduler */}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              // setSelectedLead(lead);
                              setMeetingLead(lead);
                              setMeetingData({
                                date: lead.meetingDate || "",
                                time: lead.meetingTime || "",
                                link: lead.meetingLink || "",
                              });
                              setShowMeetingModal(true);
                            }}
                            className="p-2 rounded-full bg-slate-50 border border-slate-100 text-slate-400 hover:text-[#007AB7] hover:border-[#007AB7] hover:bg-blue-50 transition-all duration-200"
                            title="Schedule Meeting"
                          >
                            <Video className="w-4 h-4" />
                          </button>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-slate-600">
                        {lead?.canton}
                      </td>
                      <td className="px-6 py-4 text-sm text-slate-600">
                        {formatGermanDate(lead?.date)}
                      </td>

                      {/* <td className="px-6 py-4 text-sm text-slate-500">
                      {lead?.notes || "-"}
                    </td> */}
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex items-center justify-center gap-1">
                          {/* View Details */}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedLead(lead);
                            }}
                            className="p-2 text-slate-400 hover:text-[#007AB7] hover:bg-blue-50 rounded-lg transition-colors"
                            title="View Details"
                          >
                            <Eye className="w-5 h-5" />
                          </button>

                          {/* Edit Lead */}
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setAddFormData({ ...lead });
                              setIsEditMode(true);
                              setShowAddModal(true);
                            }}
                            className="p-2 text-slate-400 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors"
                            title="Edit Lead"
                          >
                            <PencilLine className="w-5 h-5" />
                          </button>
                          {/* <button
                            onClick={(e) => {
                              e.stopPropagation();
                              if (activeMenu === lead?.id) {
                                setActiveMenu(null);
                              } else {
                                const rect =
                                  e.currentTarget.getBoundingClientRect();
                                setMenuPosition({
                                  top: rect.top + window.scrollY - 168,
                                  left: rect.left + window.scrollX - 160,
                                });
                                setActiveMenu(lead?.id);
                              }
                            }}
                            className="p-1 rotate-90 transition-colors rounded-md text-slate-400 hover:text-[#007AB7] hover:bg-blue-50"
                          >
                            <MoreVertical size={18} />
                          </button> */}
                        </div>
                      </td>
                      {/* <td className="px-6 py-4 text-center"> */}
                      {/* <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"> */}
                      {/* <div className="flex items-center justify-end gap-2"> */}
                      {/* VIEW ICON */}
                      {/* <button
                              onClick={() => setSelectedLead(lead)}
                              className="p-2 rounded-lg text-slate-400 hover:text-[#007AB7] hover:bg-blue-50 transition-all"
                              title="View Details"
                            >
                              <Eye className="w-4 h-4" />
                            </button> */}

                      {/* EDIT ICON */}
                      {/* <button
                              onClick={() => {
                                // Prefill the add form state with current lead data
                                setAddFormData({
                                  internalClientId:
                                    lead.internal_client_id || "",
                                  name: lead.name || "",
                                  email: lead.email || "",
                                  phone: lead.phone || "",
                                  income: lead.income || "",
                                  source: lead.source || "",
                                  notes: lead.notes || "",
                                });
                                // setExistingProfilePicUrl(lead.profile_pic || null);
                                setIsEditMode(true); // Ensure you have this state to toggle modal title
                                setEditingLeadId(lead.id); // Store ID for the update API call
                                setShowAddModal(true);
                              }}
                              className="p-2 rounded-lg text-slate-400 hover:text-amber-600 hover:bg-amber-50 transition-all"
                              title="Edit Lead"
                            >
                              <PencilLine className="w-4.5 h-4.5" />
                            </button> */}
                      {/* </div> */}

                      {/* 
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      className="px-6 py-16 text-center text-slate-400 text-sm"
                    >
                      {t("leadManagement.table.noLeads")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <Pagination
          recordsPerPage={recordsPerPage}
          setRecordsPerPage={setRecordsPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalRecords={total ?? 0}
          className="bg-theme-white"
          prevIcon="/images/arrow_drop_down.svg"
          nextIcon="/custom/next.svg"
          recordsPerPageOptions={[5, 10, 20, 50]}
        />
      </div>
      {activeMenu !== null &&
        createPortal(
          <>
            <div
              className="fixed inset-0 z-[200]"
              onClick={() => setActiveMenu(null)}
            />
            <div
              style={{ top: menuPosition.top, left: menuPosition.left }}
              className="fixed z-[201] w-48 overflow-hidden bg-white border shadow-2xl border-slate-200 rounded-xl"
            >
              {menuOptions.map((option, index) => {
                const lead = leads.find((l) => l.id === activeMenu);
                if (!lead) return null;
                return (
                  <button
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (option.name === "View Details") {
                        setSelectedLead(lead);
                        setNotes(lead?.notes || "");
                        // setSelectedAction(
                        //   lead?.status?.toLowerCase() === "contacted"
                        //     ? "contacted"
                        //     : lead?.status?.toLowerCase() === "completed"
                        //       ? "completed"
                        //       : null,
                        // );
                        setSelectedAction(lead?.status || null);
                      } else if (option.name === "Mark Contacted") {
                        apiClient
                          .post(`lead/${lead.id}`, { status: "Contacted" })
                          .then((res) => {
                            if (res.success) fetchLeads();
                          });
                      } else if (option.name === "Mark Completed") {
                        apiClient
                          .post(`lead/${lead.id}`, { status: "Completed" })
                          .then((res) => {
                            if (res.success) fetchLeads();
                          });
                      } else if (option.name === "Follow Up") {
                        apiClient
                          .post(`lead/${lead.id}`, { status: "Follow-Up" })
                          .then((res) => {
                            if (res.success) fetchLeads();
                          });
                      }
                      setActiveMenu(null);
                    }}
                    className="flex items-center w-full gap-3 px-4 py-2.5 text-sm text-slate-700 transition-colors border-b border-slate-50 last:border-none hover:bg-slate-50"
                  >
                    {option.name}
                  </button>
                );
              })}
            </div>
          </>,
          document.body,
        )}
      {/* --- Lead Details Modal --- */}
      {selectedLead && (
        <div className="fixed inset-0 z-[100] flex justify-end bg-black/40 backdrop-blur-sm transition-opacity">
          {/* Backdrop: Click outside to close */}
          <div
            className="absolute inset-0"
            onClick={() => {
              setSelectedLead(null);
              setSelectedAction(null);
              setNotes("");
            }}
          />

          {/* Sidebar Container */}
          <div className="relative flex flex-col w-full h-screen duration-300 bg-white shadow-2xl sm:max-w-md animate-in slide-in-from-right">
            {/* 1. Header (Fixed) */}
            <div className="flex items-center justify-between p-5 bg-white border-b sm:p-6 border-slate-100">
              <div className="flex items-center gap-4">
                <div className="flex items-center justify-center w-12 h-12 border rounded-full shadow-sm bg-[#007AB7] text-white font-bold text-lg">
                  {selectedLead?.contact?.name?.charAt(0)?.toUpperCase() ?? "?"}
                </div>
                <div>
                  <h2 className="text-xl font-bold leading-tight text-[#007AB7]">
                    {selectedLead?.contact?.name}
                  </h2>
                  {/* <div className="flex items-center justify-center text-[#007AB7]">
                    {selectedLead?.contact?.name}
                  </div> */}
                  <span
                    className={`px-2 py-0.5 text-[10px] font-bold rounded uppercase ${getStatusStyles(selectedLead.status)}`}
                  >
                    {selectedLead.status}
                  </span>
                </div>
              </div>
              <button
                onClick={() => {
                  setSelectedLead(null);
                  setSelectedAction(null);
                  setNotes("");
                }}
                className="p-2 transition-colors rounded-full hover:bg-slate-100 text-slate-400"
              >
                <Plus className="rotate-45" size={24} />
              </button>
            </div>

            {/* 2. Scrollable Body (Main Content) */}
            <div className="flex-1 p-5 space-y-8 overflow-y-auto scrollbar-hide sm:p-6 custom-scrollbar pb-28">
              {/* Quick Actions */}
              {/* In the Detail Slide-over / SlideOver component */}
              <div className="flex flex-col gap-4 py-4 bg-slate-50 rounded-xl border border-slate-100 px-4">
                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">
                  {t("leadManagement.sidebar.updateStatus")}
                </label>

                <div className="flex flex-col gap-3">
                  <select
                    className="w-full p-2.5 bg-white border border-slate-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-blue-500 outline-none"
                    value={selectedAction || selectedLead.status}
                    onChange={(e) => setSelectedAction(e.target.value)}
                  >
                    {ALL_STATUSES.map((status) => (
                      <option key={status} value={status}>
                        {t(`leadStatus.${status}`) || status}
                      </option>
                    ))}
                  </select>

                  {/* Conditional Meeting Date Field */}
                  {/* {selectedLead.status === "Meeting-Scheduled" && (
                    <div className="animate-in fade-in slide-in-from-top-2 duration-300">
                      <div className="flex items-center gap-1">
                        <label className="text-xs font-medium text-slate-600 mb-1 block">
                          {t("leadManagement.sidebar.meetingDate")}
                        </label>
                        <span className="text-red-500">*</span>
                      </div>

                      <div className="relative">
  <input
    type="datetime-local"
    id="meetingDateTimeHidden"
    value={selectedLead.meetingDate || ""}
    onChange={(e) => {
      handleUpdateMeetingDate(selectedLead.id, e.target.value);
    }}
    style={{
      position: "absolute",
      bottom: 0,
      right: 0,
      width: "1px",
      height: "1px",
      opacity: 0,
      pointerEvents: "none",
    }}
    tabIndex={-1}
  />

  <div
    onClick={() =>
      document.getElementById("meetingDateTimeHidden")?.showPicker()
    }
    className="w-full p-2 bg-white border border-slate-200 rounded-lg text-sm cursor-pointer flex items-center justify-between"
  >
    <span style={{ color: selectedLead.meetingDate ? "#181818" : "#9CA3AF" }}>
      {selectedLead.meetingDate
        ? formatGermanDateTime(selectedLead.meetingDate)
        : i18n.language === "de"
          ? "TT.MM.JJJJ HH:MM"
          : "DD.MM.YYYY HH:MM"}
    </span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-4 h-4 text-[#181818]"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  </div>
</div>
                    </div>
                  )} */}
                </div>
              </div>
              {/* <div className="grid grid-cols-2 gap-3">
                <button
                  onClick={() =>
                    setSelectedAction(
                      selectedAction === "contacted" ? null : "contacted",
                    )
                  }
                  className={`flex items-center justify-center gap-2 py-3 text-xs font-bold transition-all border rounded-xl sm:text-sm
      ${
        selectedAction === "contacted"
          ? "border-orange-300 bg-[#FFF8E3] text-[#A87E00] ring-2 ring-orange-300 opacity-100"
          : selectedAction !== null
            ? "border-orange-100 bg-[#FFF8E3] text-[#A87E00] opacity-40"
            : "border-orange-100 bg-[#FFF8E3] text-[#A87E00] hover:bg-orange-100"
      }`}
                >
                  <img src={DoneAll} className="w-4 h-4" alt="contacted" />
                  Mark Contacted
                </button>

                <button
                  onClick={() =>
                    setSelectedAction(
                      selectedAction === "completed" ? null : "completed",
                    )
                  }
                  className={`flex items-center justify-center gap-2 py-3 text-xs font-bold transition-all border rounded-xl sm:text-sm
      ${
        selectedAction === "completed"
          ? "border-emerald-300 bg-emerald-50 text-emerald-700 ring-2 ring-emerald-300 opacity-100"
          : selectedAction !== null
            ? "border-emerald-100 bg-emerald-50 text-emerald-700 opacity-40"
            : "border-emerald-100 bg-emerald-50 text-emerald-700 hover:bg-emerald-100"
      }`}
                >
                  <img src={check} className="w-4 h-4" alt="completed" />
                  Mark Completed
                </button>
              </div> */}

              {/* Optional Actions */}
              {/* <section>
                <p className="mb-3 text-sm font-bold text-slate-900">
                  Optional{" "}
                  <span className="font-normal text-slate-500">
                    (only if you want)
                  </span>
                </p>
                <div className="grid grid-cols-2 gap-3">
                  <button className="flex items-center justify-center gap-2 py-2.5 bg-red-50 text-[#1D61E7] rounded-xl font-bold text-sm hover:bg-red-100 transition-colors border border-red-100">
                    <img src={Archive} alt="archive" />
                    Archive
                  </button>
                  <button className="flex items-center justify-center gap-2 py-2.5 bg-red-50 text-red-600 rounded-xl font-bold text-sm hover:bg-red-100 transition-colors border border-red-100">
                    <img src={Delete} alt="arhive" />
                    Delete
                  </button>
                </div>
              </section> */}

              {/* Info Grid */}
              <section className="space-y-4">
                <h3 className="text-xs font-black tracking-widest uppercase text-slate-400">
                  {t("leadManagement.sidebar.leadInfo")}
                </h3>
                <div className="grid gap-3">
                  <div className="flex items-center gap-4 p-3 border bg-slate-50 rounded-2xl border-slate-100">
                    <div className="p-2 text-blue-500 bg-white shadow-sm rounded-xl">
                      <Mail size={18} />
                    </div>
                    <div className="overflow-hidden">
                      <p className="text-[10px] text-slate-400 font-bold uppercase">
                        {t("leadManagement.sidebar.updateStatus")}
                      </p>
                      <p className="text-sm font-semibold truncate text-slate-700">
                        {/* {selectedLead?.contact?.name?.toLowerCase()?.replace(" ", ".")} */}
                        {selectedLead?.contact?.email}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 p-3 border bg-slate-50 rounded-2xl border-slate-100">
                    <div className="p-2 text-blue-500 bg-white shadow-sm rounded-xl">
                      <Calendar size={18} />
                    </div>
                    <div className="overflow-hidden">
                      <p className="text-[10px] text-slate-400 font-bold uppercase">
                        {t("leadManagement.modal.dob")}
                      </p>
                      <p className="text-sm font-semibold truncate text-slate-700">
                        {/* {selectedLead?.contact?.name?.toLowerCase()?.replace(" ", ".")} */}
                        {formatGermanDate(
                          selectedLead?.contact?.dob ||
                            selectedLead?.contact?.birthDate,
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 p-3 border bg-slate-50 rounded-2xl border-slate-100">
                    <div className="p-2 text-blue-500 bg-white shadow-sm rounded-xl">
                      <Phone size={18} />
                    </div>
                    <div>
                      <p className="text-[10px] text-slate-400 font-bold uppercase">
                        {t("leadManagement.modal.phone")}
                      </p>
                      <p className="text-sm font-semibold text-slate-700">
                        {selectedLead?.contact?.phone}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div className="p-3 gap-4 text-center border bg-slate-50 rounded-2xl border-slate-100">
                    {/* <div className="flex items-center justify-center w-12 h-12 border rounded-full shadow-sm bg-[#007AB7] text-white font-bold text-lg">
                      {selectedLead.canton?.charAt(0)?.toUpperCase() ??
                        "?"}
                    </div> */}
                    <div>
                      <p className="text-[10px] text-slate-400 uppercase font-bold">
                        {t("leadManagement.table.canton")}
                      </p>
                      <p className="text-sm font-bold text-slate-800">
                        {selectedLead.canton}
                      </p>
                    </div>
                  </div>
                  <div className="p-3 text-center border bg-slate-50 rounded-2xl border-slate-100">
                    <p className="text-[10px] text-slate-400 uppercase font-bold">
                      {t("Income Range")}
                    </p>
                    <p className="text-sm font-bold text-slate-800">
                      {selectedLead.incomeRange}
                    </p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="p-3 gap-4 text-center border bg-slate-50 rounded-2xl border-slate-100">
                    {/* <div className="flex items-center justify-center w-12 h-12 border rounded-full shadow-sm bg-[#007AB7] text-white font-bold text-lg">
                      {selectedLead.canton?.charAt(0)?.toUpperCase() ??
                        "?"}
                    </div> */}
                    <div>
                      <p className="text-[10px] text-slate-400 uppercase font-bold">
                        Pillar 3A
                      </p>
                      <p className="text-sm font-bold text-slate-800">
                        {selectedLead?.pillar3a || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="p-3 text-center border bg-slate-50 rounded-2xl border-slate-100">
                    <p className="text-[10px] text-slate-400 uppercase font-bold">
                      Pillar 3B
                    </p>
                    <p className="text-sm font-bold text-slate-800">
                      {selectedLead?.pillar3b || "-"}
                    </p>
                  </div>
                  <div className="p-3 text-center border bg-slate-50 rounded-2xl border-slate-100">
                    <p className="text-[10px] text-slate-400 uppercase font-bold">
                      {t("Living Situation")}
                    </p>
                    <p className="text-sm font-bold text-slate-800">
                      {selectedLead?.livingSituation || "-"}
                    </p>
                  </div>
                </div>
              </section>

              {/* Call Back */}
              {/* <section>
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-sm font-bold text-slate-900">
                    Call Back Scheduling
                  </h3>
                  <button className="text-[11px] text-blue-600 font-bold hover:underline">
                    CUSTOM
                  </button>
                </div>
                <div className="space-y-2">
                  {["Tomorrow 10:00", "Upcoming 3 days", "Next Monday"].map(
                    (time, i) => (
                      <label
                        key={i}
                        className="flex items-center gap-3 p-3 transition-colors bg-white border cursor-pointer border-slate-100 rounded-xl hover:bg-slate-50"
                      >
                        <input
                          type="checkbox"
                          className="w-4 h-4 text-blue-600 rounded border-slate-300"
                        />
                        <span className="text-sm font-medium text-slate-700">
                          {time}
                        </span>
                      </label>
                    ),
                  )}
                </div>
              </section> */}

              {(selectedLead.meetingDate ||
                selectedLead.meetingTime ||
                selectedLead.meetingLink) && (
                <section className="p-4 bg-blue-50 border border-blue-100 rounded-2xl space-y-3 animate-in fade-in slide-in-from-top-2 duration-300">
                  <div className="flex items-center gap-2 text-[#007AB7]">
                    <Video size={18} />
                    <h3 className="text-sm font-bold">
                      {t("leadManagement.sidebar.title")}
                    </h3>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    {selectedLead.meetingDate && (
                      <div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase">
                          {t("leadManagement.sidebar.date")}
                        </p>
                        <p className="text-sm font-semibold text-slate-700">
                          {formatGermanDate(selectedLead.meetingDate)}
                        </p>
                      </div>
                    )}
                    {(selectedLead.meetingTime ||
                      selectedLead.meetingDate?.includes("T")) && (
                      <div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase">
                          {t("leadManagement.sidebar.time")}
                        </p>
                        <p className="text-sm font-semibold text-slate-700">
                          {selectedLead.meetingTime ||
                            selectedLead.meetingDate.split("T")[1]}
                        </p>
                      </div>
                    )}
                  </div>
                  {selectedLead.meetingLink && (
                    <div className="pt-2 border-t border-blue-100">
                      <p className="text-[10px] text-slate-400 font-bold uppercase mb-1">
                        {t("leadManagement.sidebar.meetingLink")}
                      </p>
                      <a
                        href={selectedLead.meetingLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-medium text-[#007AB7] hover:underline flex items-center gap-1 truncate"
                      >
                        {selectedLead.meetingLink}
                        <ExternalLink size={14} className="shrink-0" />
                      </a>
                    </div>
                  )}
                </section>
              )}

              {/* Notes */}
              <section>
                <h3 className="mb-2 text-sm font-bold text-slate-900">
                  {t("leadManagement.sidebar.notes")}
                </h3>
                <textarea
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  className="w-full h-32 p-4 text-sm border-none outline-none resize-none bg-slate-50 rounded-2xl focus:ring-2 focus:ring-blue-100 text-slate-600"
                  placeholder={t("leadManagement.sidebar.notesPlaceholder")}
                />
              </section>
            </div>

            {/* 3. Footer (Fixed at Bottom) */}
            <div className="p-5 sm:p-6 bg-white border-t border-slate-100 shadow-[0_-10px_40px_rgba(0,0,0,0.04)]">
              <button
                onClick={handleSave}
                disabled={!hasChanges()}
                className="w-full py-4 bg-[#007AB7] text-white rounded-xl font-bold text-base hover:bg-[#00699d] transition-all active:scale-[0.98] shadow-lg shadow-blue-100 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {t("leadManagement.sidebar.save")}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ── ADD LEAD MODAL ───────────────────────────────────────── */}
      {showAddModal &&
        createPortal(
          <div className="fixed inset-0 z-[500] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
            {/* Backdrop */}
            <div
              className="absolute inset-0"
              onClick={() => {
                setShowAddModal(false);
                setIsEditMode(false);
                resetAddForm();
              }}
            />

            {/* Modal Box */}
            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-5 border-b border-slate-100 sticky top-0 bg-white z-10">
                <h2 className="text-lg font-bold text-slate-900">
                  {isEditMode
                    ? t("leadManagement.modal.editTitle")
                    : t("leadManagement.modal.addTitle")}
                </h2>
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    setIsEditMode(false);
                    resetAddForm();
                  }}
                  className="p-2 rounded-full hover:bg-slate-100 text-slate-400 transition-colors"
                >
                  <X size={20} />
                </button>
              </div>

              {/* Body */}
              <div className="px-6 py-6 space-y-7">
                {/* Step 1: Income */}
                <div>
                  <p className="text-sm font-bold text-slate-800 mb-1">
                    {t("leadManagement.modal.annualIncome")}
                  </p>
                  <p className="text-xs text-slate-400 mb-3">
                    {t("leadManagement.modal.incomeSubtitle")}
                  </p>
                  <div className="grid grid-cols-2 gap-2">
                    {incomeOptions.map((opt) => (
                      <button
                        key={opt.key}
                        onClick={() =>
                          setAddFormData({
                            ...addFormData,
                            incomeRange: opt.key,
                          })
                        }
                        className={`px-4 py-2.5 rounded-xl border text-sm font-medium transition-all text-left ${
                          addFormData.incomeRange === opt.key
                            ? "bg-[#DBF1FF] border-[#036EA4] text-[#036EA4]"
                            : "bg-white border-slate-200 text-slate-600 hover:bg-blue-50"
                        }`}
                      >
                        {t(opt.key)}
                      </button>
                    ))}
                  </div>
                </div>

                <hr className="border-slate-100" />

                {/* Step 2: Living Situation */}
                <div>
                  <p className="text-sm font-bold text-slate-800 mb-1">
                    {t("leadManagement.modal.livingSituation")}
                  </p>
                  <p className="text-xs text-slate-400 mb-3">
                    {t("leadManagement.modal.livingSubtitle")}
                  </p>
                  <div className="grid grid-cols-2 gap-2">
                    {livingOptions.map((opt) => (
                      <button
                        key={opt}
                        onClick={() =>
                          setAddFormData({
                            ...addFormData,
                            livingSituation: opt.key,
                          })
                        }
                        className={`px-4 py-2.5 rounded-xl border text-sm font-medium transition-all text-left ${
                          addFormData.livingSituation === opt.key
                            ? "bg-[#DBF1FF] border-[#036EA4] text-[#036EA4]"
                            : "bg-white border-slate-200 text-slate-600 hover:bg-blue-50"
                        }`}
                      >
                        {t(opt.key)}
                      </button>
                    ))}
                  </div>
                </div>

                <hr className="border-slate-100" />

                {/* Step 3: Canton */}
                <div>
                  <p className="text-sm font-bold text-slate-800 mb-1">
                    {t("leadManagement.table.canton")}
                  </p>
                  <p className="text-xs text-slate-400 mb-3">
                    {t("leadManagement.modal.cantonSubtitle")}
                  </p>
                  <select
                    value={addFormData.canton}
                    onChange={(e) =>
                      setAddFormData({ ...addFormData, canton: e.target.value })
                    }
                    className="w-full p-3 rounded-xl border border-slate-200 text-sm text-slate-600 outline-none focus:border-[#036EA4] bg-white"
                  >
                    <option value="">Select your canton</option>
                    {cantonOptions.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>

                <hr className="border-slate-100" />

                {/* Step 4: Pillar 3A */}
                <div>
                  <p className="text-sm font-bold text-slate-800 mb-1">
                    {t("leadManagement.modal.pillar3a")}
                  </p>
                  <p className="text-xs text-slate-400 mb-3">
                    {t("leadManagement.modal.pillarSubtitle")}
                  </p>
                  <div className="grid grid-cols-1 gap-3">
                    {pillarsOption.map((opt) => (
                      <label
                        key={opt}
                        className="flex items-center gap-3 cursor-pointer group"
                      >
                        <div
                          onClick={() =>
                            setAddFormData({ ...addFormData, pillar3a: opt })
                          }
                          className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 border-2 transition-all cursor-pointer ${
                            addFormData.pillar3a === opt
                              ? "bg-[#036EA4] border-[#036EA4]"
                              : "bg-white border-[#036EA4]"
                          }`}
                        >
                          {addFormData.pillar3a === opt && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-3 w-3 text-white"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          )}
                        </div>
                        <span
                          onClick={() =>
                            setAddFormData({ ...addFormData, pillar3a: opt })
                          }
                          className="text-sm text-slate-600 cursor-pointer"
                        >
                          {t(opt)}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                <hr className="border-slate-100" />

                {/* Step 5: Contact Info */}
                <div>
                  <p className="text-sm font-bold text-slate-800 mb-1">
                    {t("leadManagement.modal.contactDetails")}
                  </p>
                  <p className="text-xs text-slate-400 mb-4">
                    {t("leadManagement.modal.contactSubtitle")}
                  </p>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {/* Name */}
                    <div className="flex flex-col gap-1.5">
                      <label className="text-xs font-bold uppercase tracking-wide text-slate-700">
                        {t("leadManagement.modal.fullName")}
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. Marc Müller"
                        value={addFormData.contact.name}
                        onChange={(e) =>
                          setAddFormData({
                            ...addFormData,
                            contact: {
                              ...addFormData.contact,
                              name: e.target.value,
                            },
                          })
                        }
                        onBlur={() =>
                          setAddFormErrors({
                            ...addFormErrors,
                            name: validateAddName(addFormData.contact.name),
                          })
                        }
                        className="p-3 rounded-xl border border-slate-200 text-sm outline-none focus:border-[#036EA4] bg-white"
                      />
                      {addFormErrors.name && (
                        <span className="text-xs text-red-500">
                          {addFormErrors.name}
                        </span>
                      )}
                    </div>

                    {/* Phone */}
                    <div className="flex flex-col gap-1.5">
                      <label className="text-xs font-bold uppercase tracking-wide text-slate-700">
                        {t("leadManagement.modal.phone")}
                      </label>
                      <input
                        type="tel"
                        placeholder="e.g. +41 79 123 45 67"
                        maxLength={15}
                        value={addFormData.contact.phone}
                        onChange={(e) =>
                          setAddFormData({
                            ...addFormData,
                            contact: {
                              ...addFormData.contact,
                              phone: e.target.value,
                            },
                          })
                        }
                        onBlur={() =>
                          setAddFormErrors({
                            ...addFormErrors,
                            phone: validateAddPhone(addFormData.contact.phone),
                          })
                        }
                        className="p-3 rounded-xl border border-slate-200 text-sm outline-none focus:border-[#036EA4] bg-white"
                      />
                      {addFormErrors.phone && (
                        <span className="text-xs text-red-500">
                          {addFormErrors.phone}
                        </span>
                      )}
                    </div>
                    {/* Date of Birth Field */}
                    <div className="flex flex-col gap-1.5">
                      <label className="text-xs font-bold uppercase tracking-wide text-slate-700">
                        {t("leadManagement.modal.dob")}{" "}
                        {/* <span className="text-red-500">*</span> */}
                      </label>
                      {/* <input
                        type="date"
                        value={addFormData.birthDate}
                        onChange={(e) =>
                          setAddFormData({
                            ...addFormData,
                            birthDate: e.target.value,
                          })
                        }
                        className={`px-4 py-2.5 rounded-xl border ${
                          addFormErrors.birthDate ? "border-red-500" : "border-slate-200"
                        } focus:border-[#007AB7] outline-none transition-all`}
                      />
                      {addFormErrors.birthDate && (
                        <p className="text-xs text-red-500">{addFormErrors.birthDate}</p>
                      )} */}

                      <div className="relative">
                        {/* ✅ Hidden input — right side pe bottom mein */}
                        <input
                          type="date"
                          id="birthDateHidden"
                          min={minDate}
                          max={maxDate}
                          value={addFormData.contact.birthDate}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val && val > maxDate) {
                              setAddFormErrors({
                                ...addFormData,
                                birthDate: t(
                                  "You must be at least 18 years old",
                                ),
                              });
                            } else if (val && val < minDate) {
                              setAddFormErrors({
                                ...addFormErrors,
                                birthDate: t(
                                  "Persons over 60 are not eligible for insurance policy changes",
                                ),
                              });
                            } else {
                              setAddFormErrors({
                                ...addFormErrors,
                                birthDate: null,
                              });
                            }
                            setAddFormData({
                              ...addFormData,
                              contact: {
                                ...addFormData.contact,
                                birthDate: val,
                              },
                            });
                          }}
                          style={{
                            position: "absolute",
                            bottom: 0,
                            right: 0,
                            left: 100, // ✅ right side
                            width: "1px",
                            height: "1px",
                            opacity: 0,
                            pointerEvents: "none",
                          }}
                          tabIndex={-1}
                        />

                        {/* Visible div */}
                        <div
                          onClick={() =>
                            document
                              .getElementById("birthDateHidden")
                              ?.showPicker()
                          }
                          className="flex items-center justify-between p-3 rounded-xl border border-slate-200 outline-none focus:border-[#036EA4] bg-white cursor-pointer text-sm"
                        >
                          <span
                            style={{
                              color: addFormData.contact.birthDate
                                ? "#181818"
                                : "#9CA3AF",
                            }}
                          >
                            {addFormData.contact.birthDate
                              ? i18n.language === "de"
                                ? addFormData.contact.birthDate
                                    .split("-")
                                    .reverse()
                                    .join(".")
                                : addFormData.contact.birthDate
                                    .split("-")
                                    .reverse()
                                    .join("/")
                              : i18n.language === "de"
                                ? "TT.MM.JJJJ"
                                : "DD/MM/YYYY"}
                          </span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4 text-[#181818]"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    {/* Email */}
                    <div className="flex flex-col gap-1.5">
                      <label className="text-xs font-bold uppercase tracking-wide text-slate-700">
                        {t("leadManagement.modal.email")}
                      </label>
                      <input
                        type="email"
                        placeholder="e.g. marc@example.com"
                        value={addFormData.contact.email}
                        onChange={(e) =>
                          setAddFormData({
                            ...addFormData,
                            contact: {
                              ...addFormData.contact,
                              email: e.target.value,
                            },
                          })
                        }
                        // onBlur={() =>
                        //   setAddFormErrors({
                        //     ...addFormErrors,
                        //     email: validateAddEmail(addFormData.contact.email),
                        //   })
                        // }
                        className="p-3 rounded-xl border border-slate-200 text-sm outline-none focus:border-[#036EA4] bg-white"
                      />
                      {/* {addFormErrors.email && (
                        <span className="text-xs text-red-500">
                          {addFormErrors.email}
                        </span>
                      )} */}
                    </div>
                  </div>
                </div>

                {/* Terms */}
                {/* <div className="flex items-start gap-3">
                  <input
                    type="checkbox"
                    id="add-terms"
                    checked={addFormData.termsAccepted}
                    onChange={(e) =>
                      setAddFormData({
                        ...addFormData,
                        termsAccepted: e.target.checked,
                      })
                    }
                    className="w-5 h-5 mt-0.5 cursor-pointer flex-shrink-0 accent-[#036EA4]"
                  />
                  <label
                    htmlFor="add-terms"
                    className="text-sm text-slate-500 cursor-pointer select-none"
                  >
                     {t("leadManagement.modal.terms")}
                  </label>
                </div> */}
              </div>

              {/* Footer */}
              <div className="sticky bottom-0 bg-white border-t border-slate-100 px-6 py-4 flex justify-end gap-3">
                <button
                  onClick={() => {
                    setShowAddModal(false);
                    setIsEditMode(false);
                    resetAddForm();
                  }}
                  className="px-5 py-2.5 rounded-xl border border-slate-200 text-sm font-semibold text-slate-600 hover:bg-slate-50 transition-all"
                >
                  {t("leadManagement.modal.cancel")}
                </button>
                <button
                  onClick={handleAddLead}
                  disabled={!isAddFormValid() || addFormSubmitting}
                  className="px-6 py-2.5 rounded-xl bg-[#007AB7] text-white text-sm font-bold hover:bg-[#005f8d] transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-2"
                >
                  {addFormSubmitting
                    ? t("leadManagement.modal.submitting")
                    : t("leadManagement.modal.submit")}
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}
      <PopupModal
        url="https://calendly.com/your-calendly-link" // Replace with your link
        onModalClose={() => setIsCalendlyOpen(false)}
        open={isCalendlyOpen}
        rootElement={document.getElementById("root")}
        onEventScheduled={onDateScheduled}
        /* Pass prefill data so the user doesn't have to type their name/email again */
        prefill={{
          email: selectedLead?.contact?.email,
          name: selectedLead?.contact?.name,
        }}
      />
      {showMeetingModal && (
        <div className="fixed inset-0 z-[600] flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
            <div className="flex items-center justify-between p-6 border-b border-slate-100">
              <h3 className="text-xl font-bold text-slate-900">
                {t("leadManagement.meetingModal.title")}
              </h3>
              <button
                onClick={() => setShowMeetingModal(false)}
                className="p-2 hover:bg-slate-100 rounded-full text-slate-400 transition-colors"
              >
                <X size={20} />
              </button>
            </div>
            {/* <div className="p-6 space-y-5">
              <div>
                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-2">
                  {t("leadManagement.meetingModal.date")}
                </label>
                <input
                  type="date"
                  className="w-full p-3 rounded-xl border border-slate-200 outline-none focus:border-[#007AB7] text-sm"
                  value={meetingData.date}
                  onChange={(e) =>
                    setMeetingData({ ...meetingData, date: e.target.value })
                  }
                />
              </div>
              <div>
                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-2">
                  {t("leadManagement.meetingModal.time")}
                </label>
                <input
                  type="time"
                  className="w-full p-3 rounded-xl border border-slate-200 outline-none focus:border-[#007AB7] text-sm"
                  value={meetingData.time}
                  onChange={(e) =>
                    setMeetingData({ ...meetingData, time: e.target.value })
                  }
                />
              </div>
              <div>
                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-2">
                  {t("leadManagement.meetingModal.link")}
                </label>
                <input
                  type="url"
                  placeholder={t("leadManagement.meetingModal.linkPlaceholder")}
                  className="w-full p-3 rounded-xl border border-slate-200 outline-none focus:border-[#007AB7] text-sm"
                  value={meetingData.link}
                  onChange={(e) =>
                    setMeetingData({ ...meetingData, link: e.target.value })
                  }
                />
              </div>
            </div> */}
            <div className="p-6 space-y-5">
  {/* Date Input with Custom Display */}
  <div>
    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-2">
      {t("leadManagement.meetingModal.date")}
    </label>
    <div className="relative">
      {/* Hidden date input */}
      <input
        type="date"
        id="meetingDateHidden"
        value={meetingData.date}
        onChange={(e) =>
          setMeetingData({ ...meetingData, date: e.target.value })
        }
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          left: 100,
          width: "1px",
          height: "1px",
          opacity: 0,
          pointerEvents: "none",
        }}
        tabIndex={-1}
      />

      {/* Visible display div */}
      <div
        onClick={() =>
          document.getElementById("meetingDateHidden")?.showPicker()
        }
        className="flex items-center justify-between p-3 rounded-xl border border-slate-200 outline-none focus:border-[#007AB7] bg-white cursor-pointer text-sm"
      >
        <span
          style={{
            color: meetingData.date ? "#181818" : "#9CA3AF",
          }}
        >
          {meetingData.date
            ? i18n.language === "de"
              ? meetingData.date.split("-").reverse().join(".")
              : meetingData.date.split("-").reverse().join(".")
            : i18n.language === "de"
              ? "TT.MM.JJJJ"
              : "DD.MM.YYYY"}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4 text-[#181818]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      </div>
    </div>
  </div>

  {/* Time Input with Custom Display */}
  <div>
    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-2">
      {t("leadManagement.meetingModal.time")}
    </label>
    <div className="relative">
      {/* Hidden time input */}
      <input
        type="time"
        id="meetingTimeHidden"
        value={meetingData.time}
        onChange={(e) =>
          setMeetingData({ ...meetingData, time: e.target.value })
        }
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          left: 100,
          width: "1px",
          height: "1px",
          opacity: 0,
          pointerEvents: "none",
        }}
        tabIndex={-1}
      />

      {/* Visible display div */}
      <div
        onClick={() =>
          document.getElementById("meetingTimeHidden")?.showPicker()
        }
        className="flex items-center justify-between p-3 rounded-xl border border-slate-200 outline-none focus:border-[#007AB7] bg-white cursor-pointer text-sm"
      >
        <span
          style={{
            color: meetingData.time ? "#181818" : "#9CA3AF",
          }}
        >
          {meetingData.time || "HH:MM"}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4 text-[#181818]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
    </div>
  </div>

  {/* Link Input - Keep as is */}
  <div>
    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-2">
      {t("leadManagement.meetingModal.link")}
    </label>
    <input
      type="url"
      placeholder={t("leadManagement.meetingModal.linkPlaceholder")}
      className="w-full p-3 rounded-xl border border-slate-200 outline-none focus:border-[#007AB7] text-sm"
      value={meetingData.link}
      onChange={(e) =>
        setMeetingData({ ...meetingData, link: e.target.value })
      }
    />
  </div>
</div>
            <div className="p-6 bg-slate-50 flex justify-end gap-3">
              <button
                onClick={() => setShowMeetingModal(false)}
                className="px-5 py-2.5 rounded-xl border border-slate-200 text-sm font-semibold text-slate-600 hover:bg-white transition-all"
              >
                {t("leadManagement.meetingModal.cancel")}
              </button>
              <button
                onClick={handleMeetingSubmit}
                disabled={meetingSubmitting || !meetingData.date}
                className="px-6 py-2.5 rounded-xl bg-[#007AB7] text-white text-sm font-bold hover:bg-[#005f8d] transition-all disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {meetingSubmitting
                  ? t("leadManagement.meetingModal.saving")
                  : t("leadManagement.meetingModal.save")}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Translated Status Sub Menu with Search */}
      {openSubMenuId &&
        createPortal(
          <div
            className="fixed z-[600] bg-white border border-slate-100 rounded-2xl shadow-2xl overflow-hidden py-2 min-w-[280px] max-h-[440px] flex flex-col"
            style={{ top: subMenuPosition.top, left: subMenuPosition.left }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="px-4 py-3 border-b border-slate-100">
              <p className="text-[10px] font-black uppercase tracking-widest text-slate-400 mb-2">
                {t("leadManagement.updateStatus")}
              </p>

              {/* Search Input */}
              <div className="relative">
                <input
                  type="text"
                  placeholder={
                    t("leadManagement.searchStatusPlaceholder") ||
                    "Search status..."
                  }
                  className="w-full pl-9 py-2 text-sm bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-[#007AB7]"
                  value={subMenuSearchTerm}
                  onChange={(e) => setSubMenuSearchTerm(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                />
                <Search
                  size={16}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                />
              </div>
            </div>

            {/* Scrollable Status List */}
            <div className="flex-1 overflow-y-auto custom-scrollbar-thin py-1 max-h-[340px]">
              {ALL_STATUSES.filter((status) => {
                const displayText = t(`leadStatus.${status}`) || status;
                return displayText
                  .toLowerCase()
                  .includes(subMenuSearchTerm.toLowerCase());
              }).map((status) => {
                const displayText = t(`leadStatus.${status}`) || status;
                const currentStatus = leads.find(
                  (l) => l.id === openSubMenuId,
                )?.status;

                return (
                  <button
                    key={status}
                    onClick={() => handleSubStatusChange(openSubMenuId, status)}
                    className={`w-full text-left px-4 py-3 text-sm font-medium text-slate-700 hover:bg-blue-50 hover:text-[#007AB7] transition-all
                       flex items-center justify-between group
                       ${status === currentStatus && "bg-[#E0F2FE]"}
                       `}
                  >
                    <span>{displayText}</span>
                    {/* {status === currentStatus && (
                      <CheckCircle size={16} className="text-emerald-500" />
                    )} */}
                  </button>
                );
              })}

              {ALL_STATUSES.filter((status) => {
                const displayText = t(`leadStatus.${status}`) || status;
                return displayText
                  .toLowerCase()
                  .includes(subMenuSearchTerm.toLowerCase());
              }).length === 0 && (
                <div className="px-4 py-8 text-center text-slate-400 text-sm">
                  {t("leadManagement.noStatusFound") ||
                    "No matching status found"}
                </div>
              )}
            </div>
          </div>,
          document.body,
        )}{" "}
    </section>
  );
}
